import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ItineraryService} from "../../../core/services/itinerary.service";
import {NzMessageService} from "ng-zorro-antd/message";
import {Location} from "@angular/common";
import {AuthService} from "../../../modules/auth/services/auth.service";
import {SettingService} from "../../../core/services/setting.service";
import {LanguageService} from "../../../core/services/language.service";
import * as moment from "moment/moment";
import {CountryService} from "../../../core/services/country.service";
import {getAccommodationPerDate} from "../../../core/ult-functions/accommodation";
import {convertAmount} from "../../../core/ult-functions/currency-calculation";
import {getConditionBadge as resolveConditionBadge} from "../../../core/ult-functions/condition-badge";
import {SETTINGS} from "../../../core/config/common.settings";
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-cost-breakdown',
  templateUrl: './cost-breakdown.component.html',
  styleUrls: ['./cost-breakdown.component.scss']
})
export class CostBreakdownComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private countryService: CountryService,
    private itineraryService: ItineraryService,
    private message: NzMessageService,
    private _location: Location,
    private authService: AuthService,
    private settingService: SettingService,
    private languageService: LanguageService,
    private translocoService: TranslocoService) {
  }

  isAdd = false;
  rId: any;
  destinations: any[] = [];
  singleItinerary: any;
  destination: any = {};
  overviewDescription = "";
  remarksTips = "";
  selectedLanguages: any = [];
  languages: any[] = [];
  paymentLink = "";
  brand: any;
  accommodations: any = [];
  cardLoading = true;
  countriesJson: any = [];
  additionalCosts: any = [];
  accVatPercentage = 0;

  // cost Settings
  isSubTotalManual = false;

  // exclude pre
  excludeCost: any = [];
  exchangeRate = 0;
  secondaryCurrency = "";
  currency = "";
  protected readonly getAccommodationPerDate = getAccommodationPerDate;
  protected readonly convertAmount = convertAmount;
  protected readonly SETTINGS = SETTINGS;
  protected readonly getConditionBadge = resolveConditionBadge;

  ngOnInit(): void {
    this.rId = this.route.snapshot.paramMap.get("id");
    this.getCountries().then();
    this.getLanguages().then();
    Promise.all([this.loadItineraryByID()]).then(async () => {
      this.cardLoading = false;
      // this.accommodations = getAccommodationPerDate(this.singleItinerary.days[this.tabIndex].date);
    });
  }

  async loadItineraryByID(): Promise<void> {
    try {
      this.singleItinerary = await this.itineraryService.getItineraryById({
        id: this.rId,
      });
      await this.findBrand();
      if (this.singleItinerary.costing) {
        this.excludeCost = this.singleItinerary?.excludePredefinedCost || [];
        const {additionalCosts} = this.singleItinerary?.costing;
        const {predefinedCosting} = this.brand;
        this.additionalCosts.push(...additionalCosts);
        const filteredPredefinedCosting = predefinedCosting.filter(
          (item: any) => !this.excludeCost.some((excludeItem: any) => excludeItem.id === item._id)
        ).filter((costing: { active: boolean; }) => costing.active);
        this.additionalCosts.push(...filteredPredefinedCosting);
      }

      this.exchangeRate = this.singleItinerary.tour?.exchangeRate ?? 0;
      this.secondaryCurrency = this.singleItinerary.tour?.secondaryCurrency ?? "";
      this.currency = this.singleItinerary.tour.currency;
    } catch (e) {
    }
  }

  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.brand = brand;
    this.accVatPercentage = brand?.accVatPercentage ?? 0;
    this.selectedLanguages = brand?.selectedLanguages || [];
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  customizeDate(value: string, setting: string): string {
    return moment(value).format(setting);
  }

  findCountryFlagImage(countryCode: string): string {
    const selected_country = this.countriesJson.find(
      (c: any) => c.code === countryCode
    );
    return selected_country?.image;
  }

  async getCountries(): Promise<void> {
    this.countriesJson = await this.countryService.getCountries();
  }

  displayTitle(titles: any, defaultLanguage: string): string {
    return titles
      .filter((item: any) => item?.language === defaultLanguage)
      .map((item: any) => item?.name);
  }

  calculateExperienceTotalCost(cAdult: number, cChild: number, cInfant: number): number {
    return cAdult * this.singleItinerary.tour.pax.adults +
      cChild * this.singleItinerary.tour.pax.children +
      cInfant * this.singleItinerary.tour.pax.infants;
  }

  calculateExperiencesCostPerDay(experiences: any): number {
    const pax = this.singleItinerary?.tour?.pax;
    const adults = pax?.adults ?? 0;
    const children = pax?.children ?? 0;
    const infants = pax?.infants ?? 0;
    let exp = 0;
    experiences.forEach((item: any) => {
      if (item?.conditionType !== 'EXC') {
        const costType = item?.costType ?? 'perPerson';
        const isPrimary = item?.isPrimaryCurrency ?? true;
        const exchangeRate = this.exchangeRate || 1;

        if (costType === 'free') {
          // no cost
        } else if (costType === 'perGroup') {
          const groupTotal = item?.costing?.totalCost || 0;
          exp += isPrimary ? groupTotal : groupTotal / exchangeRate;
        } else {
          // perPerson
          const personTotal = item?.costing?.totalCost
            ? item.costing.totalCost
            : ((item?.costPerAdult || 0) * adults) +
              ((item?.costPerChild || 0) * children) +
              ((item?.costPerInfant || 0) * infants);
          exp += isPrimary ? personTotal : personTotal / exchangeRate;
        }
      }
    });
    return exp;
  }

  calculateAccommodationPerDay(accommodations: any): number {
    let totalAccommodation = 0;
    const exchangeRate = this.exchangeRate || 1;
    accommodations.forEach((accommodation: any) => {
      const isPrimary = accommodation?.isPrimaryCurrency ?? true;
      const totalCost = isPrimary
        ? (accommodation?.totalCost || 0)
        : (accommodation?.totalCost || 0) / exchangeRate;
      totalAccommodation += totalCost;
    });
    return totalAccommodation;
  }

  calculateTransportTotalCostPerDay(transports: any): number {
    let totalTransport = 0;
    const exchangeRate = this.exchangeRate || 1;
    transports.forEach((trans: any) => {
      const isPrimary = trans?.isPrimaryCurrency ?? true;
      const totalCost = isPrimary
        ? (trans?.totalCost || 0)
        : (trans?.totalCost || 0) / exchangeRate;
      totalTransport += totalCost;
    });
    return totalTransport;
  }

  calculateAccPax(cChild: number, cInfant: number, isPrimary: boolean): number {
    const exchangeRate = this.exchangeRate || 1;
    const costChild = isPrimary ? cChild : cChild / exchangeRate;
    const costInfant = isPrimary ? cInfant : cInfant / exchangeRate;
    return +costChild * this.singleItinerary.tour.pax.children +
      +costInfant * this.singleItinerary.tour.pax.infants;
  }

  calculateSubTotalPerDay(isLeisureDay: boolean, exp: any, transport: any, acc: any, day?: any): number {
    const additionalCosts = this.getDayAdditionalCostsTotal(day);
    let subTotal = 0;
    if (!isLeisureDay) {
      subTotal = this.calculateExperiencesCostPerDay(exp) +
        this.calculateTransportTotalCostPerDay(transport) +
        this.calculateAccommodationPerDay(acc) +
        additionalCosts;
      return subTotal;
    } else {
      subTotal = this.calculateTransportTotalCostPerDay(transport) +
        additionalCosts;
      return subTotal;
    }
  }

  findLanguageByCode(code: any): string {
    const langArray = this.languages;
    const selectedLang = langArray.find(
      (element: any) => element.code === code
    )?.name;

    if (!selectedLang) {
      return this.getEmptyValue();
    }
    return selectedLang;
  }



  sortTransportByLand(transport: any[]): any[] {
      return transport.filter(item => item.typeOfVehicle === 'land');
  }
  sortTransportByNotLand(transport: any[]): any[] {
      return transport.filter(item => item.typeOfVehicle !== 'land');
  }

  getExtraCostTotal(extraCost: any[], isPrimary: boolean): number {
    const exchangeRate = this.exchangeRate || 1;
    return (extraCost ?? []).reduce((sum: number, item: any) => {
      const cost = isPrimary ? (item.cost ?? 0) : (item.cost ?? 0) / exchangeRate;
      return sum + cost;
    }, 0);
  }

  calculatePerGroupTotalCost(exp: any): number {
    const isPrimary = exp?.isPrimaryCurrency ?? true;
    const exchangeRate = this.exchangeRate || 1;
    const groupTotal = exp?.costing?.totalCost || 0;
    return isPrimary ? groupTotal : groupTotal / exchangeRate;
  }

  calculatePerGroupMarkup(exp: any): number {
    const isPrimary = exp?.isPrimaryCurrency ?? true;
    const exchangeRate = this.exchangeRate || 1;
    const markup = exp?.costing?.markup ?? 0;
    return isPrimary ? markup : markup / exchangeRate;
  }

  calculatePerPersonTotalCost(exp: any): number {
    const isPrimary = exp?.isPrimaryCurrency ?? true;
    const exchangeRate = this.exchangeRate || 1;
    const pax = this.singleItinerary?.tour?.pax;
    const adults = pax?.adults ?? 0;
    const children = pax?.children ?? 0;
    const infants = pax?.infants ?? 0;
    const personTotal = exp?.costing?.totalCost
      ? exp.costing.totalCost
      : ((exp?.costPerAdult || 0) * adults) +
        ((exp?.costPerChild || 0) * children) +
        ((exp?.costPerInfant || 0) * infants);
    return isPrimary ? personTotal : personTotal / exchangeRate;
  }

  calculatePerPersonMarkup(exp: any): number {
    const isPrimary = exp?.isPrimaryCurrency ?? true;
    const exchangeRate = this.exchangeRate || 1;
    const markup = exp?.costing?.markup ?? 0;
    return isPrimary ? markup : markup / exchangeRate;
  }

  hasAdvancedOptions(experiences: any[]): boolean {
    return experiences.some((exp: any) =>
      exp?.advancedOptions?.isChecked === true
    );
  }

  getExpByType(experiences: any[], costType: string): any[] {
    return experiences.filter((exp: any) => (exp?.costType ?? 'perPerson') === costType);
  }

  hasExpOfType(experiences: any[], costType: string): boolean {
    return experiences.some((exp: any) => (exp?.costType ?? 'perPerson') === costType);
  }

  getTotalPerPersonMarkup(experiences: any[]): number {
    return experiences.reduce((sum: number, exp: any) => {
      if (exp?.conditionType === 'EXC') return sum;
      if ((exp?.costType ?? 'perPerson') !== 'perPerson') return sum;
      return sum + this.calculatePerPersonMarkup(exp);
    }, 0);
  }

  getTotalPerGroupMarkup(experiences: any[]): number {
    return experiences.reduce((sum: number, exp: any) => {
      if (exp?.conditionType === 'EXC') return sum;
      if ((exp?.costType ?? 'perPerson') !== 'perGroup') return sum;
      return sum + this.calculatePerGroupMarkup(exp);
    }, 0);
  }

  getDayAdditionalCostsTotal(day: any): number {
    const costs = day?.additionalCosts ?? [];
    return costs.reduce((sum: number, ac: any) => sum + (ac?.cost ?? 0), 0);
  }

  getTotalDayAdditionalCosts(): number {
    return (this.singleItinerary?.days ?? []).reduce((sum: number, day: any) => {
      return sum + this.getDayAdditionalCostsTotal(day);
    }, 0);
  }

  calculateTotalTourCost(): number {
    const pax = this.singleItinerary?.tour?.pax;
    const amountOfAdult = pax?.adults ?? 0;
    const amountOfChildren = pax?.children ?? 0;
    const amountOfInfant = pax?.infants ?? 0;
    const exchangeRate = this.singleItinerary?.tour?.exchangeRate || 1;

    let totalExperiences = 0;
    let totalAccommodation = 0;
    let totalTransport = 0;

    // Experiences
    this.singleItinerary.experiences.forEach((day: any, idx: number) => {
      if (!this.singleItinerary.days[idx].isLeisureDay) {
        day.experiencesPerDay.forEach((experience: any) => {
          if (experience.conditionType !== 'EXC') {
            const costType = experience?.costType ?? 'perPerson';
            const isPrimary = experience?.isPrimaryCurrency ?? true;

            if (costType === 'free') {
              // no cost
            } else if (costType === 'perGroup') {
              const groupTotal = experience?.costing?.totalCost || 0;
              totalExperiences += isPrimary ? groupTotal : groupTotal / exchangeRate;
            } else {
              const personTotal = experience?.costing?.totalCost
                ? experience.costing.totalCost
                : ((experience?.costPerAdult || 0) * amountOfAdult) +
                  ((experience?.costPerChild || 0) * amountOfChildren) +
                  ((experience?.costPerInfant || 0) * amountOfInfant);
              totalExperiences += isPrimary ? personTotal : personTotal / exchangeRate;
            }
          }
        });
      }
    });

    // Accommodation & Transport
    this.singleItinerary.days.forEach((day: any) => {
      if (!day.isLeisureDay) {
        this.singleItinerary.accommodation.forEach((accommodation: any) => {
          const checkIn = new Date(accommodation.checkIn);
          const checkOut = new Date(accommodation.checkOut);
          const dayDate = new Date(day.date);
          if (dayDate >= checkIn && dayDate < checkOut) {
            const isPrimary = accommodation?.isPrimaryCurrency ?? true;
            const totalCost = accommodation?.totalCost || 0;
            totalAccommodation += isPrimary ? totalCost : totalCost / exchangeRate;
          }
        });
      }

      (day.transport ?? []).forEach((transport: any) => {
        const isPrimary = transport?.isPrimaryCurrency ?? true;
        const totalCost = transport?.totalCost || 0;
        totalTransport += isPrimary ? totalCost : totalCost / exchangeRate;
      });
    });

    // Day additional costs
    let totalDayAdditionalCosts = 0;
    this.singleItinerary.days.forEach((day: any) => {
      if (day.additionalCosts && Array.isArray(day.additionalCosts)) {
        day.additionalCosts.forEach((ac: any) => {
          totalDayAdditionalCosts += (ac.cost || 0);
        });
      }
    });

    return totalExperiences + totalAccommodation + totalTransport + totalDayAdditionalCosts;
  }

  getEmptyValue(): string {
    return this.translocoService.translate('itineraries.costBreakdown.common.emptyValue');
  }

  getDayLabel(day: number): string {
    return this.translocoService.translate('itineraries.costBreakdown.common.dayLabel', { day });
  }

  getDayWithDateLabel(day: number, date: any): string {
    return this.translocoService.translate('itineraries.costBreakdown.common.dayWithDateLabel', {
      day,
      date: moment(date).format('D MMM YYYY').toUpperCase()
    });
  }

  getCostingTypeLabel(): string {
    if (!this.singleItinerary?.costSettings?.isSubTotalManual && !this.singleItinerary?.costing?.costBreak) {
      return this.translocoService.translate('itineraries.costBreakdown.clientTourInformation.costingTypes.auto');
    }
    if (this.singleItinerary?.costSettings?.isSubTotalManual && !this.singleItinerary?.costing?.costBreak) {
      return this.translocoService.translate('itineraries.costBreakdown.clientTourInformation.costingTypes.manual');
    }
    return this.translocoService.translate('itineraries.costBreakdown.clientTourInformation.costingTypes.custom');
  }

  getNumberOfDaysLabel(noOfDays: number): string {
    return noOfDays !== 1
      ? this.translocoService.translate('itineraries.costBreakdown.clientTourInformation.days')
      : this.translocoService.translate('itineraries.costBreakdown.clientTourInformation.day');
  }

  getVatLabel(isTaxed: boolean): string {
    return isTaxed
      ? this.translocoService.translate('itineraries.costBreakdown.accommodation.vatIncluded')
      : this.translocoService.translate('itineraries.costBreakdown.accommodation.vatExcluded');
  }

  getTransportModeLabel(typeOfVehicle: string): string {
    if (typeOfVehicle === 'land') {
      return this.translocoService.translate('itineraries.costBreakdown.transport.land');
    }
    return typeOfVehicle;
  }

  getAdditionalCostTypeLabel(symbol: string): string {
    return symbol === 'PERCENT'
      ? this.translocoService.translate('itineraries.costBreakdown.costing.percentage')
      : this.translocoService.translate('itineraries.costBreakdown.costing.fixed');
  }

  getMarkupSymbolLabel(symbol: string): string {
    return symbol === 'PERCENT' ? '%' : this.currency;
  }

  getLeisureDayLabel(): string {
    return this.translocoService.translate('itineraries.costBreakdown.dayCard.leisureDay');
  }

  getDepartureLabel(): string {
    return this.translocoService.translate('itineraries.costBreakdown.dayCard.departure');
  }
}
